// useIntegrations.ts
import { useContext, useEffect, useState } from "react";
import { DataContext } from "../context/data.context";

export function useIntegrations(selectedCategory: string = "Featured") {
    const [loading, setLoading] = useState<boolean>(false);
    const [category, setCategory] = useState<string>(selectedCategory);
    const [allIntegrations, setAllIntegrations] = useState<any>();
    const { categories } = useContext(DataContext);

    useEffect(() => {
        setLoading(true);
        setCategory(selectedCategory);
        setLoading(false);
    }, [selectedCategory]);

    useEffect(() => {
        const currentCategory = categories?.find(
            (cat) => cat.attributes.name === category
        );
        if (currentCategory) {
            const sortedIntegrations = currentCategory.attributes.integrations.data.sort(
                (a, b) => a.attributes.sort - b.attributes.sort
            );
            const featured = sortedIntegrations.filter(
                (integration) => integration.attributes.featured === true && integration.attributes.active === true
            );
            const nonFeatured = sortedIntegrations.filter(
                (integration) => integration.attributes.featured === false && integration.attributes.active === true
            );
            setAllIntegrations([...featured, ...nonFeatured]);
        }
    }, [category, categories]);

    return { loading, category, categories, setCategory, allIntegrations };
}
